<template>
    <div class="gas-info-card">
        <b-card no-body
                class="overflow-hidden shadow border-0 main-card"
        >
            <div class="card-header-custom">
                <div class="header-content">
                    <i class="fa fa-warning header-icon"
                       v-if="classification.classification && classification.classification.category"
                    />
                    <i class="fa fa-check header-icon"
                       v-else
                    />
                    <h5 class="mb-0">{{ classification.danger.name }}</h5>
                </div>
            </div>

            <b-row no-gutters
                   v-if="classification.classification && classification.classification.category"
            >
                <b-col md="8">
                    <b-card-body class="content-section">
                        <div class="info-section">
                            <div class="info-row">
                                <div class="info-label">Clase:</div>
                                <div class="info-value">
                                    <span class="text-uppercase fw-bold">
                                        {{ classification.classification.danger.name }}
                                    </span>
                                </div>
                            </div>

                            <b-row>
                                <b-col>
                                    <div class="info-row">
                                        <div class="info-label">Categoría:</div>
                                        <div class="info-value">
                                            <span class="category-badge">
                                                {{ classification.classification.category }}
                                            </span>
                                        </div>
                                    </div>
                                </b-col>

                                <b-col v-if="classification.classification.sub_category">
                                    <div class="info-row">
                                        <div class="info-label">Subcategoría:</div>
                                        <div class="info-value">
                                            <span class="subcategory-badge">{{
                                                    classification.classification.sub_category.toUpperCase()
                                                }}</span>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>

                            <div class="info-row">
                                <div class="info-label">Código e indicación de peligro:</div>
                                <div class="info-value mt-1"
                                     v-for="sga_category in classification.classification.sga_categories"
                                     :key="sga_category.id"
                                >
                                    <span class="code-badge">{{ sga_category.category.codigo }}</span>
                                    <span class="warning-text">{{
                                            sga_category.category.codigos.descripcion.toUpperCase()
                                        }}</span>
                                </div>

                                <div class="info-value"
                                     v-if="!classification.classification.sga_categories.length"
                                >
                                    SIN INDICACIONES DE PELIGRO
                                </div>
                            </div>

                            <div class="info-row">
                                <div class="info-label">Palabra de advertencia:</div>
                                <div class="info-value"
                                     v-if="classification.classification.word_of_warning"
                                >
                                    <span class="danger-badge"
                                        v-if="classification.classification.word_of_warning === 'PELIGRO'"
                                    >
                                        {{
                                            classification.classification.word_of_warning
                                        }}
                                    </span>
                                    <span class="warning-badge"
                                          v-else
                                    >
                                        {{
                                            classification.classification.word_of_warning
                                        }}
                                    </span>
                                </div>
                                <div class="info-value"
                                     v-else
                                >
                                    SIN PALABRA DE ADVERTENCIA
                                </div>
                            </div>

                            <div class="info-row">
                                <div class="info-label">
                                    Justificación:

                                    <b-btn variant="primary"
                                           size="sm"
                                           class="float-right py-0"
                                           style="padding-bottom: 1px !important"
                                           v-if="show_button"
                                           @click="_saveClassification(classification.classification)"
                                    >
                                        Guardar
                                    </b-btn>
                                </div>
                                <div class="info-value">
                                    <el-input type="textarea"
                                              :rows="4"
                                              placeholder="Justificación"
                                              v-model="classification.classification.justification"
                                              @input="setShowButton()"
                                    />

                                </div>
                            </div>

                            <!-- Justificaciones complementarias -->
                            <div v-if="classification.classification && classification.classification.complementary_justifications && classification.classification.complementary_justifications.length" class="info-row">
                                <div class="info-label mb-2">
                                    Justificaciones complementarias:
                                </div>
                                <div v-for="cj in classification.classification.complementary_justifications.filter(j => j.classification === 1)" :key="cj.id" class="complementary-justification-row">
                                    <b-form-checkbox :checked="cj.selected" :id="'cj-' + cj.id" class="pull-left"
                                        @change="onComplementaryJustificationChangeCheckbox($event, cj)">
                                        <label :for="'cj-' + cj.id" class="custom-checkbox-label text-muted">
                                            {{ cj.justification }}
                                        </label>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </b-card-body>
                </b-col>

                <b-col md="4"
                       class="pictogram-column"
                >
                    <div class="pictogram-container">
                        <div class="pictogram-wrapper">
                            <img v-if="classification.classification.image_pictogram"
                                 :src="classification.classification.image_pictogram"
                                 :alt="classification.classification.danger.name"
                                 class="p-3"
                            >
                            <div v-else
                                 class="pictogram-wrapper not-classified"
                            >
                                <i class="fa fa-ban not-classified-icon"></i>
                            </div>
                        </div>
                        <div class="pictogram-label"
                             v-if="classification.classification.image_pictogram"
                        >
                            <span>PICTOGRAMA</span>
                        </div>
                        <div class="pictogram-label"
                             v-else
                        >
                            <span>SIN PICTOGRAMA</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row no-gutters
                   v-else
            >
                <b-col md="8">
                    <b-card-body class="content-section">
                        <div class="info-section">
                            <div class="info-row">
                                <div class="info-label">Estado de clasificación:</div>
                                <div class="info-value">
                                    <span class="not-classified-badge">No clasificado</span>
                                </div>
                            </div>

                            <div class="classification-notice mt-4">
                                <i class="fa fa-info-circle notice-icon"></i>
                                <p class="notice-text">NO SE CUMPLEN LOS CRITERIOS DE CLASIFICACIÓN DEL SGA, PARA ESTA
                                    CLASE DE PELIGRO</p>
                            </div>

                                <!-- Justificaciones complementarias para no clasificados -->
                                <div v-if="classification.classification && classification.classification.complementary_justifications && classification.classification.complementary_justifications.length"
                                    class="info-row">
                                    <div class="info-label mb-2">
                                        Justificaciones complementarias:
                                    </div>
                                    <div v-for="cj in classification.classification.complementary_justifications.filter(j => j.classification === 0)" :key="cj.id" class="complementary-justification-row">
                                        <b-form-checkbox :checked="cj.selected" :id="'cj-' + cj.id" class="pull-left"
                                            @change="onComplementaryJustificationChangeCheckbox($event, cj)">
                                            <label :for="'cj-' + cj.id" class="custom-checkbox-label text-muted">
                                                {{ cj.justification }}
                                            </label>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                        </div>
                    </b-card-body>
                </b-col>

                <b-col md="4"
                       class="pictogram-column"
                >
                    <div class="pictogram-container">
                        <div class="pictogram-wrapper not-classified">
                            <i class="fa fa-ban not-classified-icon"></i>
                        </div>
                        <div class="pictogram-label">
                            <span>NO APLICA</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'danger_card',
    props: {
        classification: {
            required: true
        }
    },
    computed: {
        ...mapState('calculator', ['product']),
        ...mapGetters('calculator', ['getComplementaryJustificationsState']),
        filteredComplementaryJustifications() {
            if (!this.classification.complementary_justifications) return [];
            const isClassified = !!this.classification.cal_danger_class_id;
            return this.classification.complementary_justifications.filter(j =>
                j.classification === (isClassified ? 1 : 0)
            );
        }
    },
    data() {
        return {
            show_button: false
        };
    },
    async mounted() {
        if (this.classification.classification && this.classification.classification.complementary_justifications) {
            this.classification.classification.complementary_justifications.forEach(justification => {
                justification.selected = !!justification.selected;
            });
        }
    },
    beforeDestroy() {
        if (this.classification.classification && this.classification.classification.complementary_justifications) {
            this.saveJustificationsState();
        }
    },
    methods: {
        ...mapActions('calculator', [
            'saveClassificationComplementaryJustification',
            'deleteClassificationComplementaryJustification',
            'getSavedComplementaryJustifications',
            'saveComplementaryJustificationsState'
        ]),
        setShowButton() {
            this.show_button = true;
        },
        _saveClassification(classification) {
            this.$emit('saveClassification', classification);
            this.show_button = false;
        },
      
        /**
         * Maneja el evento de cambio (check/uncheck) en la casilla de verificación de una justificación complementaria.
         * Actualiza el estado en el backend (guarda o elimina la relación en la base de datos) y sincroniza el estado en Vuex.
         */
        async onComplementaryJustificationChangeCheckbox(checked, justification) {
            try {
                justification.selected = checked;
                // Crea el payload
                const payload = {
                    classification_id: this.getClassificationId(),
                    complementary_justification_id: justification.id,
                    company_id: this.getCompanyId()
                };
                
                if (justification.selected) {
                    await this.saveClassificationComplementaryJustification(payload);
                } else {
                    await this.deleteClassificationComplementaryJustification(payload);
                }
                
                this.saveJustificationsState();
                
            } catch (error) {
                
                justification.selected = !checked;
                
                if (error.response && error.response.status === 401) {
                    console.log('Error de autenticación, no mostrar error de justificación complementaria');
                    return;
                }
                
                console.error('Error en petición justificación complementaria:', error);
            }
        },

        /**
         * Carga el estado de las justificaciones complementarias guardadas para la clasificación actual.
         * Sincroniza el estado visual de los checkboxes según los datos almacenados en Vuex.
         */
        async loadSavedComplementaryJustifications() {
            try {
                const savedState = this.getComplementaryJustificationsState(this.getClassificationId());
                
                if (savedState && savedState.length > 0) {
                    this.classification.classification.complementary_justifications.forEach(justification => {
                        const savedJustification = savedState.find(saved => saved.id === justification.id);
                        justification.selected = savedJustification ? savedJustification.selected : !!justification.selected;
                    });
                }
            } catch (error) {
                console.error('Error al cargar justificaciones complementarias guardadas:', error);
            }
        },

        /**
         * Guarda el estado actual de las justificaciones complementarias en Vuex para la clasificación actual.
         * Esto permite mantener la selección de checkboxes sincronizada localmente.
         */
        saveJustificationsState() {
            const justifications = this.classification.classification.complementary_justifications.map(justification => ({
                id: justification.id,
                selected: justification.selected
            }));
            
            this.saveComplementaryJustificationsState({
                classification_id: this.getClassificationId(),
                justifications: justifications
            });
        },

        getClassificationId() {
            return this.classification.classification.id;
        },

        getCompanyId() {
            return this.product.slq_company_id;
        }
    }
};
</script>

<style scoped>
.gas-info-card {
    margin: 0.3rem auto;
    font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.main-card {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2) !important;
    margin: 0.8rem auto;
}

.card-header-custom {
    border: 1px solid #fff;
    background: #ebebeb;
    color: black;
    padding: 0.5rem 1rem;
}

.header-content {
    display: flex;
    align-items: center;
}

.header-icon {
    font-size: 1rem;
    margin-right: 1rem;
}

.content-section {
    padding: 0.4rem 1.5rem;
}

.info-section {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
}

.info-row {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 0.5rem;
}

.info-label {
    font-weight: 600;
    color: #555;
    margin-bottom: 0.1rem;
}

.info-value {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.category-badge {
    background: linear-gradient(135deg, #ed7e00 0%, #ffa600 100%);
    color: white;
    padding: 0 0.6rem;
    border-radius: 5px;
    font-weight: bold;
    font-size: 0.9rem;
}

.subcategory-badge {
    background: linear-gradient(135deg, #ed7e00 0%, #ffa600 100%);
    color: white;
    padding: 0 0.6rem;
    border-radius: 5px;
    font-weight: bold;
    font-size: 0.9rem;
}

.code-badge {
    background-color: #f0f0f0;
    color: #333;
    padding: 0.3rem 0.6rem;
    border-radius: 4px;
    font-family: monospace;
    font-weight: bold;
    font-size: 0.9rem;
}

.warning-text {
    font-weight: 500;
}

.warning-badge {
    background: linear-gradient(135deg, #ed7e00 0%, #ffa600 100%);
    color: white;
    padding: 0 0.6rem;
    border-radius: 5px;
    font-weight: bold;
    letter-spacing: 0.5px;
}

.danger-badge {
    background: linear-gradient(135deg, #ed0000 0%, #ff0000 100%);
    color: white;
    padding: 0 0.6rem;
    border-radius: 5px;
    font-weight: bold;
    letter-spacing: 0.5px;
}

.pictogram-column {
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
    display: flex;
    align-items: center;
    justify-content: center;
}

.pictogram-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 100%;
}

.pictogram-wrapper {
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    padding: 0rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.pictogram-wrapper img {
    width: 100%;
    height: auto;
}

.pictogram-label {
    color: #666;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 1px;
}

.pictogram-wrapper.not-classified {
    background-color: #f8f9fa;
    border: 2px dashed #dee2e6;
}

.not-classified-icon {
    font-size: 5rem;
    color: #adb5bd;
}

.not-classified-badge {
    background: linear-gradient(135deg, #1dac27 0%, #0cb700 100%);
    color: white;
    padding: 0 0.6rem;
    border-radius: 6px;
    font-weight: bold;
    font-size: 0.9rem;
}

.classification-notice {
    background-color: #f8f9fa;
    border-left: 4px solid #1dac27;
    padding: 1rem;
    margin-top: 1rem;
    display: flex;
    align-items: flex-start;
    border-radius: 4px;
}

.notice-icon {
    color: #1dac27;
    font-size: 1.2rem;
    margin-right: 0.8rem;
    margin-top: 0.2rem;
}

.notice-text {
    margin: 0;
    font-weight: 500;
    color: #333;
}

.complementary-justification-row {
    margin-bottom: 0.3rem;
}

.custom-checkbox-label {
    flex: 1;
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    line-height: 1.4;
    margin-top: 3px;
    cursor: pointer;  
    font-size: 12px;
}

@media (max-width: 767.98px) {
    .info-row {
        flex-direction: column;
    }

    .info-label {
        margin-bottom: 0.5rem;
    }

    .pictogram-wrapper {
        width: 120px;
        height: 120px;
    }
}
</style>
